export const colors = ['#FFADAD', '#FFD6A5', '#FBF8CC', '#CAFFBF', '#9BF6FF', '#A0C4FF', '#BDB2FF', '#FFC6FF'];

export const colorFromAddress = (address: string) => {
    const firstLetter = address[2].toUpperCase();
    const firstLetterHex = parseInt(firstLetter, 16);
    const colorValue = firstLetterHex % colors.length;
    return colors[colorValue];
}

export default colorFromAddress;